import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ANSWERS = 'answers'
export const SUB_QUESTIONS = 'sub questions'
export const ALPHABET = 'alphabet'
export const NUMBER = 'number'
export const RANDOM = 'random'
export const EXCLUSIVE = 'exclusive'
export const FIXED = 'fixed'
export const ADD = 'add'
export const MODAL_TEXT_REMOVE_ALTERNATIVE = 'modal-text'
export const OPERATOR = 'operator'
export const QUESTION = 'question'
export const ANSWER = 'answer'
export const SUB_QUESTION = 'sub question'
export const BULK_ADD_OR_EDIT = 'bulk-add-or-edit'
export const PREFIX_SUFFIX = 'prefix-sufiixx'
export const PREFIX = 'PREFIXX'
export const SUFFIX = 'sufiixx'
export const USER_INPUT = 'user-input'

export default {
  [PORTUGUESE]: {
    [ANSWERS]: 'Respostas',
    [SUB_QUESTIONS]: 'Sub-perguntas',
    [ALPHABET]: 'Alfabeto',
    [NUMBER]: 'Número',
    [RANDOM]: 'Aleatório',
    [PREFIX_SUFFIX]: 'Prefixo/Sufixo',
    [PREFIX]: 'Prefixo',
    [SUFFIX]: 'Sufixo',
    [EXCLUSIVE]: 'Exclusivo',
    [FIXED]: 'Fixo',
    [ADD]: 'Adicionar',
    [MODAL_TEXT_REMOVE_ALTERNATIVE]: currentAlternative =>
      `Essa ${currentAlternative} está sendo referenciado no fluxo. Tem certeza de que deseja excluir? Se você escolher "Sim" todas as condições que têm ${currentAlternative} serão deletados`,
    [OPERATOR]: 'Operador',
    [QUESTION]: 'Pergunta',
    [ANSWER]: 'Resposta',
    [SUB_QUESTION]: 'Sub-pergunta',
    [BULK_ADD_OR_EDIT]: 'Adicionar ou editar em massa',
    [USER_INPUT]: 'User input',
  },

  [ENGLISH]: {
    [ANSWERS]: 'Answers',
    [SUB_QUESTIONS]: 'Sub Questions',
    [ALPHABET]: 'Alphabet',
    [NUMBER]: 'Number',
    [RANDOM]: 'Random',
    [PREFIX_SUFFIX]: 'Prefix/Suffix',
    [PREFIX]: 'Prefix',
    [SUFFIX]: 'Sufix',
    [EXCLUSIVE]: 'Exclusive',
    [FIXED]: 'Fixed',
    [ADD]: 'Add',
    [MODAL_TEXT_REMOVE_ALTERNATIVE]: currentAlternative =>
      `This ${currentAlternative} is being referenced in the flow. Are you sure you want to delete? If you choose "Yes" all conditions that have this ${currentAlternative} will be deleted`,
    [OPERATOR]: 'Operator',
    [QUESTION]: 'Question',
    [ANSWER]: 'Answer',
    [SUB_QUESTION]: 'Sub Question',
    [BULK_ADD_OR_EDIT]: 'Bulk add or edit',
    [USER_INPUT]: 'User input',
  },

  [SPANISH]: {
    [ANSWERS]: 'Respuestas',
    [SUB_QUESTIONS]: 'Sub-preguntas',
    [ALPHABET]: 'Alfabeto',
    [NUMBER]: 'Número',
    [RANDOM]: 'Aleatorio',
    [EXCLUSIVE]: 'Exclusivo',
    [PREFIX]: 'Prefixo',
    [SUFFIX]: 'Sufixo',
    [PREFIX_SUFFIX]: 'Prefixo/Sufixo',
    [FIXED]: 'Fijar',
    [ADD]: 'Agregar',
    [MODAL_TEXT_REMOVE_ALTERNATIVE]: currentAlternative =>
      `Ese ${currentAlternative} se hace referencia en el flujo. ¿Estas seguro que quieres borrarlo? Si elige "Sí" todas las condiciones que tienen este ${currentAlternative} será borrado`,
    [OPERATOR]: 'Operador',
    [QUESTION]: 'Pregunta',
    [ANSWER]: 'Respuesta',
    [SUB_QUESTION]: 'Sub-pregunta',
    [BULK_ADD_OR_EDIT]: 'Agregar o editar en bloque',
    [USER_INPUT]: 'User input',
  },
}
